<template>
  <div
    class="tw-pb-20"
    :class="{ '!tw-pb-32': currentCandidate.disable_followups || isAdminView }"
  >
    <div
      class="tw-p-6"
      :class="{
        'tw-bg-gray-100': isAdminView && currentCandidateEmailHistory.length,
      }"
    >
      <div class="tw-flex tw-items-start tw-gap-3 tw-justify-between tw-pr-6">
        <div>
          <div class="d-flex align-items-center justify-content-center">
            <Typography variant="headline-5">
              Conversation with {{ currentCandidate?.name }}
            </Typography>
          </div>
        </div>
        <div>
          <div class="tw-flex tw-items-center tw-gap-3">
            <IconButton
              v-if="showSelection"
              class="tw-w-10 tw-h-10 tw-items-center tw-justify-center tw-flex"
              @click="changeCurrentCandidate(-1)"
              ><v-icon>mdi-chevron-left</v-icon></IconButton
            >
            <IconButton
              v-if="showSelection"
              class="tw-w-10 tw-h-10 tw-items-center tw-justify-center tw-flex"
              @click="changeCurrentCandidate(1)"
              ><v-icon>mdi-chevron-right</v-icon></IconButton
            >
            <v-tooltip left color="#fff" :disabled="isDisabledEdit">
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  <IconButton
                    :loading="loading"
                    class="tw-w-10 tw-h-10 tw-items-center tw-justify-center tw-flex"
                    @click="onDisableFollowups"
                  >
                    <img
                      v-if="currentCandidate.disable_followups"
                      :src="PlayIcon"
                    />

                    <img v-else :src="PauseIcon" />
                  </IconButton>
                </div>
              </template>
              <div class="tw-text-white tw-px-2">
                <Typography variant="body-2">
                  {{
                    !currentCandidate.disable_followups
                      ? 'Disable followups for this candidate'
                      : 'Re-enable followups for this candidate'
                  }}
                </Typography>
              </div>
            </v-tooltip>
            <v-tooltip left color="#fff" :disabled="isDisabledEdit">
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  <IconButton
                    :disabled="isDisabledEdit"
                    class="tw-w-10 tw-h-10 tw-items-center tw-justify-center tw-flex"
                    @click="editEmail = true"
                  >
                    <img :src="EditEmailIcon" />
                  </IconButton>
                </div>
              </template>
              <div class="tw-text-white tw-px-2">
                <Typography variant="body-2"
                  >Update candidate's preferred email address</Typography
                >
              </div>
            </v-tooltip>
          </div>
        </div>
      </div>
      <Typography variant="subtitle-1" class="tw-mt-4">
        <div
          v-if="
            currentCandidateEmailHistory &&
            currentCandidateEmailHistory !== null &&
            currentCandidateEmailHistory.length
          "
        >
          <v-tooltip color="#F1F2F6" bottom disabled>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <span>{{ currentCandidateEmailHistory[0].email_subject }}</span>
              </div>
            </template>
            <span>
              {{ currentCandidateEmailHistory[0].email_subject }}
            </span>
          </v-tooltip>
        </div>
      </Typography>
      <div
        v-if="
          currentCandidateEmailHistory &&
          currentCandidateEmailHistory !== null &&
          currentCandidateEmailHistory.length
        "
        ref="thread"
        class="threads"
      >
        <div ref="threads">
          <div
            v-for="(item, i) in currentCandidateEmailHistory"
            :key="`thread_${i}`"
          >
            <div>
              <template>
                <div>
                  <div
                    class="tw-mt-3 tw-border-0 tw-border-t tw-border-solid tw-border-gray-300 tw-pt-3"
                  >
                    <div
                      class="tw-cursor-pointer tw-flex tw-justify-between tw-items-center tw-gap-2 tw-relative tw-pr-6"
                      @click="expandThread(i)"
                    >
                      <div class="tw-flex tw-items-center tw-gap-2">
                        <div>
                          <div class="tw-w-[42px] tw-h-[42px]">
                            <CustomImage
                              :src="profilePicture(item)"
                              class="tw-w-full tw-h-full tw-object-cover"
                              :emptySrc="
                                require('@/assets/img/empty_avatar.png')
                              "
                              width="42"
                              height="42"
                            />
                          </div>
                        </div>
                        <div>
                          <Typography variant="body-2">
                            {{ item.from_email }}
                          </Typography>
                          <Typography variant="caption" class="tw-text-gray-700"
                            >To: {{ item.to_email }}</Typography
                          >
                        </div>
                      </div>
                      <div>
                        <Typography
                          variant="caption"
                          class="tw-text-gray-700"
                          >{{ item.date }}</Typography
                        >
                      </div>
                      <span
                        class="tw-absolute tw-top-1/2 tw-right-0 -tw-translate-y-1/2"
                      >
                        <v-icon>{{
                          threadToggle === i ? 'mdi-menu-up' : 'mdi-menu-down'
                        }}</v-icon>
                      </span>
                    </div>
                    <Typography
                      variant="body-2"
                      class="tw-py-3 tw-whitespace-break-spaces w-full"
                      :class="{ 'tw-hidden': threadToggle !== i }"
                    >
                      <div
                        class="whitespace-pre-line"
                        v-html="removeTrackingCode(item.email_body)"
                      ></div>
                    </Typography>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="isAdminView"
      class="tw-bg-purple-200 tw-z-10 tw-absolute tw-bottom-0 tw-left-0 tw-w-full tw-text-sm tw-leading-5"
      :class="{ '!tw-z-50': openMenu || isOutreachTemplateButtonsOpen }"
    >
      <div
        class="tw-flex tw-items-center tw-justify-between tw-px-3 tw-pt-[135px] md:tw-pt-[62px] tw-pb-3"
      >
        <div class="tw-flex tw-items-center tw-gap-3">
          <v-menu
            v-model="openMenu"
            top
            nudge-bottom="140px"
            nudge-left="100px"
            origin="center center"
            transition="scale-transition"
            :close-on-content-click="false"
            :close-on-click="false"
            class="tw-z-50"
          >
            <template v-slot:activator="{ on, attrs }">
              <div
                class="tw-cursor-pointer tw-w-10 tw-h-10 tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-bg-white hover:tw-bg-yellow-200 transition-colors"
                v-bind="attrs"
                v-on="on"
              >
                <img :src="boltIcon" />
              </div>
            </template>
            <div
              class="tw-bg-white tw-rounded-lg tw-shadow-shadow-2 tw-w-[472px] tw-p-6 tw-relative"
            >
              <div class="tw-absolute tw-top-3 tw-right-3">
                <v-btn icon @click="openMenu = false">
                  <v-icon>fas fa-times</v-icon>
                </v-btn>
              </div>
              <Typography variant="subtitle-1" class="tw-mb-4">
                Insert shortcut answers
              </Typography>
              <v-radio-group v-model="textValue" column hide-details>
                <div
                  v-for="(item, i) in quickAnswers"
                  :key="i"
                  class="tw-py-1 tw-text-gray-900"
                >
                  <v-radio color="#6B7280" :value="item.text">
                    <template v-slot:label>
                      <Typography variant="body-1">{{ item.name }}</Typography>
                    </template>
                  </v-radio>
                  <Typography
                    v-if="textValue === item.text"
                    variant="body-1"
                    class="tw-ml-8 tw-border tw-border-solid tw-border-gray-400 tw-rounded-lg tw-p-3"
                  >
                    <v-textarea
                      v-if="textValue === 'Compensation'"
                      v-model="compensation_template"
                      hide-details
                    ></v-textarea>
                    <v-textarea
                      v-if="textValue === 'Remote Work Policy'"
                      v-model="remote_template"
                      hide-details
                    ></v-textarea>
                    <v-textarea
                      v-if="textValue === 'Visa Sponsorship'"
                      v-model="visa_template"
                      hide-details
                    ></v-textarea>
                    <v-textarea
                      v-if="textValue === 'Attach Resume'"
                      v-model="info_request_template"
                      hide-details
                    ></v-textarea>
                    <v-textarea
                      v-if="textValue === 'Additional Information'"
                      v-model="additionalInformation"
                      hide-details
                    ></v-textarea>
                  </Typography>
                </div>
              </v-radio-group>
              <div class="tw-mt-6 tw-flex tw-justify-end">
                <Button @click="insertEmail"> Save & Insert </Button>
              </div>
            </div>
          </v-menu>
          <div>
            <OutreachTemplateButtons
              ref="outreachTemplateButtonsRef"
              @insert-variable="insertVariable"
              @open="isOutreachTemplateButtonsOpen = true"
              @close="isOutreachTemplateButtonsOpen = false"
            />
          </div>
          <div>
            <div
              class="tw-cursor-pointer tw-w-10 tw-h-10 tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-bg-white hover:tw-bg-gray-100 transition-colors"
              @mousedown.prevent="onLink(false)"
            >
              <img :src="LinkedIcon" alt="" />
            </div>
          </div>
        </div>
        <div v-if="candidates && candidates.length">
          <Button :disabled="!isValid" size="small" @click="emailSend = true"
            >Send</Button
          >
        </div>
      </div>
    </div>

    <div v-if="isAdminView" class="tw-bg-white tw-p-6 tw-pt-0">
      <div
        class="tw-py-3 tw-border-0 tw-border-b tw-border-solid tw-border-gray-300"
      >
        <div class="tw-flex tw-items-center tw-gap-2">
          <div>
            <div class="tw-w-[42px] tw-h-[42px]">
              <CustomImage
                :src="profilePicture(currentCandidateEmailHistory[0])"
                class="tw-w-full tw-h-full tw-object-cover tw-rounded-full tw-overflow-hidden"
                :emptySrc="require('@/assets/img/empty_avatar.png')"
                width="42"
                height="42"
              />
            </div>
          </div>
          <div>
            <Typography variant="body-2">
              {{ outreachSender }}
            </Typography>
            <Typography variant="caption" class="tw-text-gray-700"
              >To: {{ currentCandidate.thread_email }}</Typography
            >
          </div>
        </div>
      </div>
      <Tooltip v-model="tooltipCopy" x="140px" y="-180px" triangle="bottom">
        <div class="tooltip-body">
          <div class="tooltip__title">
            <span>Note: Current Email Sender is Hirefly</span>
          </div>
          <div class="tooltip__content">
            <p>
              The email to the candidate is initiated by Hirefly, so please keep
              in mind that you will be answering on behalf of Hirefly to help us
              act as the intermediary until you hit "Schedule Interview". After
              a candidate is moved to the "Scheduling" tab, we will officially
              introduce you to the candidate to take it to the next step - a
              first interview!
            </p>
          </div>
        </div>
      </Tooltip>
      <div>
        <VueEditor
          id="editorTool"
          v-model="emailBodyText"
          :editorToolbar="customToolbar"
          placeholder="Type Your Message Here"
          class="tab__field tab__field--textarea insert-area custom-textarea"
          @keydown.native.enter="openModalWithEnter"
          @focus="maybeShowEmailTooltip"
        />

        <AddLink
          v-if="isAddLink"
          :text="selectedText"
          :url="selectedLink"
          class="tw-absolute tw-top-[200px] tw-left-22"
          :style="dynamicPosition"
          @close="onCloseLink()"
          @update="onAddLink"
        />

        <v-dialog v-model="emailSend" width="26rem" persistent>
          <v-card>
            <v-card-title class="headline grey lighten-2">
              Are you sure want to send email?
            </v-card-title>

            <v-card-text class="mt-4">
              You are about to send an email to the candidate on behalf of
              {{ outreachSender }}. Do you wish to proceed?
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="emailSend = false">
                cancel
              </v-btn>
              <v-btn
                color="primary"
                text
                :loading="contactButtonLoading"
                @click="contactCandidate"
              >
                Yes
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </div>
    <div
      v-else
      class="tw-absolute tw-bottom-0 tw-left-0 tw-w-full tw-p-3 tw-bg-white"
    >
      <div
        v-if="currentCandidate.disable_followups"
        class="tw-bg-red-50 tw-mb-3 tw-flex tw-items-center tw-justify-between tw-gap-2 tw-p-3 tw-rounded-lg"
      >
        <div class="tw-flex tw-items-center tw-gap-2">
          <div>
            <img :src="WarningIcon" />
          </div>
          <Typography variant="body-2"
            >All followups were disabled for this candidate.</Typography
          >
        </div>
        <div>
          <Button size="small" @click="onDisableFollowups">Enable</Button>
        </div>
      </div>
      <div
        class="tw-bg-yellow-50 tw-flex tw-items-center tw-gap-2 tw-p-3 tw-rounded-lg"
      >
        <div>
          <img :src="infoIcon" />
        </div>
        <Typography variant="body-2"
          >Hirefly is managing the correspondence.</Typography
        >
      </div>
    </div>
    <v-snackbar v-model="emailSuccessSnackBar" multi-line>
      <div class="font-weight-bold">Successfully sent email</div>

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="emailSuccessSnackBar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar v-model="emailErrorSnackBar" multi-line>
      <div class="font-weight-bold">
        Couldn't send email. Please try another outreach option.
      </div>

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="emailErrorSnackBar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar v-model="unauthorizedSnackbar" multi-line>
      <div class="font-weight-bold">
        The sender you selected has not given Hirefly permission to access their
        email. Please select another sender.
      </div>

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="emailErrorSnackBar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar v-model="emailSymbolErrorSnackBar" multi-line>
      <div class="font-weight-bold">
        Your invitation message cannot exceed 300 characters
      </div>

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="emailSymbolErrorSnackBar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar v-model="loginErrorSnackBar" multi-line>
      <div class="font-weight-bold">
        Could not add your LinkedIn account. Please contact this candidate on
        your own
      </div>

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="loginErrorSnackBar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar v-model="inmailSuccessSnackBar" multi-line>
      <div class="font-weight-bold">Successfully sent InMail</div>

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="inmailSuccessSnackBar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar v-model="invitationSuccessSnackBar" multi-line>
      <div class="font-weight-bold">Successfully sent LinkedIn invitation</div>

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="invitationSuccessSnackBar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar v-model="inmailErrorSnackBar" multi-line>
      <div class="font-weight-bold">
        Couldn't send InMail. Please try another outreach option.
      </div>

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="inmailErrorSnackBar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar v-model="invitationErrorSnackBar" multi-line>
      <div class="font-weight-bold">
        Couldn't send LinkedIn invitation. Please try another outreach option.
      </div>

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="invitationErrorSnackBar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar v-model="notFoundEmailErrorSnackBar" multi-line>
      <div class="font-weight-bold">
        No email addresses were found for this candidate. Please select another
        outreach option to contact this candidate.
      </div>

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="notFoundEmailErrorSnackBar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar v-model="foundEmailSuccessSnackBar" multi-line>
      <div class="font-weight-bold">
        {{ foundEmailNumber }}
        {{ foundEmailNumber > 1 ? 'emails' : 'email' }} found. Please select an
        email address and send your email.
      </div>

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="foundEmailSuccessSnackBar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <!-- LinkedIn login dialog -->
    <v-dialog v-model="linkedinDialog.signin" :width="linkedinDialog.width">
      <v-container fluid class="dialog sign-in-dialog position-relative">
        <v-icon
          size="26"
          class="dialog__close-btn position-absolute"
          @click="linkedinDialog.signin = false"
          >mdi-close</v-icon
        >
        <v-row class="mb-4">
          <h5 class="dialog__title w-100">Sign in with LinkedIn</h5>
        </v-row>
        <v-row class="mt-4 mb-7">
          <p class="dialog__text m-0">
            You’ll need to sign in with your LinkedIn account to send InMail and
            connection requests to candidates. We do not store your username or
            password.
          </p>
        </v-row>
        <form @submit.prevent="signinLinkedin">
          <v-text-field
            v-model="linkedinLogin.username"
            outlined
            dense
            :height="32"
            placeholder="Username"
            color="grayLight"
            class="dialog__text-field"
          />
          <v-text-field
            v-model="linkedinLogin.password"
            outlined
            dense
            :height="32"
            placeholder="Password"
            color="grayLight"
            class="dialog__text-field"
            type="password"
          />

          <div class="mt-4 px-7">
            <v-btn
              block
              large
              :height="46"
              :loading="linkedinDialog.signinLoading"
              type="submit"
              color="primary"
              class="dialog__button"
              >Login</v-btn
            >
          </div>
        </form>
      </v-container>
    </v-dialog>

    <!-- Two steps dialog -->
    <v-dialog v-model="linkedinDialog.twoStep" :width="linkedinDialog.width">
      <v-container fluid class="dialog two-step-dialog position-relative">
        <v-icon
          size="26"
          class="dialog__close-btn position-absolute"
          @click="linkedinDialog.twoStep = false"
          >mdi-close</v-icon
        >
        <v-row class="mb-4">
          <h5 class="dialog__title w-100">Two Step Authentication</h5>
        </v-row>
        <v-row class="mt-4 mb-16">
          <p class="dialog__text w-100">
            You will receive a security code from LinkedIn via email or text
            message. Please enter the security code here.
          </p>
        </v-row>
        <form class="d-container" @submit.prevent="verifyLinkedin">
          <v-row class="code-form__row">
            <v-col cols="3" class="pr-0">
              <span class="code-label mt-2 d-block">Code</span>
            </v-col>
            <v-col cols="9">
              <v-text-field
                v-model="verifyCode"
                outlined
                dense
                :height="32"
                color="grayLight"
                class="dialog__text-field field-code"
              />
            </v-col>
          </v-row>

          <div class="px-7">
            <v-btn
              block
              large
              :height="46"
              :loading="linkedinDialog.twoStepLoading"
              type="submit"
              color="primary"
              class="dialog__button"
              >Verify</v-btn
            >
          </div>
        </form>
      </v-container>
    </v-dialog>

    <!-- Success dialog -->
    <v-dialog v-model="linkedinDialog.success" :width="linkedinDialog.width">
      <v-container fluid class="dialog two-step-dialog position-relative">
        <v-icon
          size="26"
          class="dialog__close-btn position-absolute"
          @click="linkedinDialog.success = false"
          >mdi-close</v-icon
        >

        <h5 class="dialog__title space-bottom w-100">Success!</h5>
        <h6 class="dialog__subtitle w-100 m-0">
          You can now send LinkedIn outreach through Hirefly.
        </h6>
        <v-row class="dialog__text-block space-bottom mt-4">
          <p class="dialog__text w-100 m-0">
            Note: You can turn off these features anytime on your Profile
            Settings page.
          </p>
        </v-row>
        <div class="d-flex justify-content-center mt-5">
          <v-icon color="success" size="120">mdi-check-circle-outline</v-icon>
        </div>
      </v-container>
    </v-dialog>

    <!-- Error dialog -->
    <v-dialog v-model="linkedinDialog.error" :width="linkedinDialog.width">
      <v-container fluid class="dialog two-step-dialog position-relative">
        <v-icon
          size="26"
          class="dialog__close-btn position-absolute"
          @click="linkedinDialog.error = false"
          >mdi-close</v-icon
        >

        <h5 class="dialog__title space-bottom w-100">Error!</h5>
        <v-row class="dialog__text-block mt-4 mb-8">
          <p class="dialog__text w-100 m-0">
            Sorry, we were unable to connect your LinkedIn account. Please
            contact candidates on your own.
          </p>
        </v-row>
        <div class="d-flex justify-content-center">
          <v-icon color="error" size="120">mdi-close-circle-outline</v-icon>
        </div>
        <v-row class="mt-8">
          <v-col cols="6" class="d-flex justify-content-end">
            <v-btn
              outlined
              text
              color="grayLight"
              width="110"
              @click="showPopupByName('signin')"
              >Try again</v-btn
            >
          </v-col>
          <v-col cols="6">
            <v-btn
              dark
              color="primaryDark"
              width="110"
              @click="linkedinDialog.error = false"
              >Ok</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-dialog>
    <v-snackbar
      v-model="showSuccessSnackbar"
      color="white"
      class="contacted-snackbar"
    >
      <div class="d-flex justify-content-center">
        <VIcon class="mr-4" color="#4F46E5" size="22">fas fa-check</VIcon>
        <span class="success-title">Success: Email Sent!</span>
      </div>
      <br />
      <span class="success-text"
        >Your Reply has been sent to the candidate</span
      >
    </v-snackbar>
    <!-- <date-picker ref="date-picker" v-model="picker" /> -->
    <v-dialog v-if="openDialog" v-model="openDialog" width="90%">
      <ExpandedEmailPopup
        :inAutoSwipeMode="isAutopilot"
        :currentCandidateEmailHistory="currentCandidateEmailHistory"
        :avalableCollaborators="avalableCollaborators"
        :currentCandidate="currentCandidate"
        :teamMembers="team_members"
        :newMailSubject="newMailSubject"
        :emailBodyText="emailBodyText"
        :selectedTemplate="selectedTemplate"
        :dropdownActiveItemId="dropdownActiveItemId"
        :dropdownItems="dropdownItems"
        :listTitle="listTitle"
        :loading="loading"
        :isDisableClick="isDisableClick"
        :openFullSizeMenu="openFullSizeMenu"
        :textValue="textValue"
        :remoteTemplate="remote_template"
        :compensationTemplate="compensation_template"
        :visaTemplate="visa_template"
        :infoRequestTemplate="info_request_template"
        :isValid="isValid"
        :sender="sender"
        :availableSenders="availableSenders"
        :calendarUser="calendar_user"
        :selected_subject="selectedSubject"
        @changeCompensationTemplate="compensation_template = $event"
        @close="openDialog = false"
        @contactCandidate="contactCandidate"
        @insertEmail="insertEmail"
        @onDateChanged="onDateChanged"
        @onTimeChanged="onTimeChanged"
        @scheduleSet="scheduleSet"
        @approveAndSend="approveAndSend"
        @sendWithEnter="sendWithEnter"
        @updateTeamMember="team_members = $event"
        @changeNewMailSubject="newMailSubject = $event"
        @changeEmailBodyText="emailBodyText = $event"
        @changeOpenFullSizeMenu="openFullSizeMenu = $event"
        @changeSender="sender = $event"
        @changeCalendarUser="calendar_user = $event"
        @changeSelectedSubject="selectedSubject = $event"
        @changeSelectedTemplate="selectedTemplate = $event"
        @changeDropdownActiveItemId="dropdownActiveItemId = $event"
        @changeText="textValue = $event"
        @changeRemoteTemplate="remote_template = $event"
        @changeVisaTemplate="visa_template = $event"
        @changeInfoRequestTemplate="info_request_template = $event"
      />
    </v-dialog>
    <v-dialog v-model="editEmail" max-width="500">
      <div class="tw-bg-white tw-p-6 tw-rounded-lg">
        <v-form ref="form">
          <Typography variant="headline-6" class="tw-mb-4">
            Update {{ currentCandidate.name }}’s email address
          </Typography>
          <Typography variant="subtitle-1" class="tw-mb-2">
            New email address
          </Typography>
          <v-text-field
            v-model="inputEmail"
            :rules="updateEmailRules"
            required
            outlined
            dense
            placeholder="name@yourdomain.com"
          ></v-text-field>
          <Typography variant="body-2" class="tw-mt-3"
            >All future conversation with Jennifer will be directed to this new
            email address.</Typography
          >
          <div class="tw-mt-8 tw-flex tw-justify-between">
            <div>
              <Button variant="text" @click="editEmail = false">Cancel</Button>
            </div>
            <div>
              <Button :loading="emailLoading" @click="updateEmail">Save</Button>
            </div>
          </div>
        </v-form>
      </div>
    </v-dialog>
    <v-snackbar
      v-model="showEmailSuccessSnackbar"
      color="white"
      class="contacted-snackbar"
    >
      <div class="d-flex justify-content-center">
        <span class="success-title">Email address updated</span>
      </div>
    </v-snackbar>
    <v-snackbar v-model="snackbar">{{ alertMessage }}</v-snackbar>
    <CalendarRequestPermission
      v-if="showAuthenticationModal"
      :scope="scope"
      @cancel="cancelAuth"
      @next-login="onNextLogin"
    />
    <v-dialog v-model="isCalendarProcess" width="25rem" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Calendar setup required
        </v-card-title>

        <v-card-text class="mt-4">
          It seems you have not set up your calendar yet. We cannot schedule
          candidate interviews until you do
        </v-card-text>

        <!-- <v-divider></v-divider> -->

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#999" text @click="isCalendarProcess = false">
            Cancel
          </v-btn>
          <router-link :to="`/calendar?projectId=${this.projectId}`">
            <v-btn color="primaryDark" text>
              Go to Calendar Page
            </v-btn></router-link
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/* eslint-disable no-underscore-dangle */
import Vue from 'vue';
import { post, get, put } from '@/js/api/sourcer';
import consola from 'consola';
import Config from '@/js/config';
import { required } from '@/js/rules';
import {
  isJSON,
  debounce,
  convertEmailTemplate,
  convertEmailTemplateForLinkedIn,
  emailRules,
} from '@/utils/';
import moment from 'moment';
import axios from 'axios';
import { VueEditor } from 'vue2-editor';
import FakeEmail from '@/assets/img/fake-email.png';
import Typography from '@/components/v3/base/Typography';
import CustomImage from '@/components/card/CustomImage';
import IconButton from '@/components/v3/base/IconButton';
import infoIcon from '@/assets/icons/info-icon.svg';
import boltIcon from '@/assets/icons/bolt-icon.svg';
import {
  insertVariable,
  addTextToElement,
} from '@/components/project/components/components/utils';
import OutreachTemplateButtons from '@/components/project/components/components/OutreachTemplateButtons';
import Button from '@/components/v3/base/Button';
import LinkedIcon from '@/assets/icons/link-icon.svg';
import AddLink from '@/components/v3/base/AddLink';
import WarningIcon from '@/assets/icons/warning-red.svg';
import EditEmailIcon from '@/assets/icons/edit-email.svg';
import PauseIcon from '@/assets/icons/pause-icon.svg';
import PlayIcon from '@/assets/icons/play-icon.svg';

const NO_FOUND_EMAIL_TEXT = 'No email address found';
const NO_DATA_AVAILABLE = 'No data available';

export default {
  components: {
    VueEditor,
    ExpandedEmailPopup: () => import('./ExpandedEmailPopup'),
    Tooltip: () => import('../project/components/Tooltip'),

    CalendarRequestPermission: () =>
      import(
        '@/components/v2/project/components/form-controls/CalendarRequestPermission'
      ),

    Typography,
    CustomImage,
    IconButton,
    OutreachTemplateButtons,
    Button,
    AddLink,
  },

  props: {
    candidates: Array,
    projectId: String,
    tab: String,
    isFullSize: Boolean,
    showFakeCard: Boolean,
    isCalibration: Boolean,
  },

  data() {
    const project = this.$store.getters['projects/getProjectById'](
      this.projectId
    );
    const needsEmailConfirmation = project
      ? project.needs_email_confirmation || // TODO(jeremiah): delete this line after v2 migration
        project.confirm_email_before_send
      : false;
    const {
      compensation_template = '',
      remote_template = '',
      visa_template = '',
      info_request_template = '',
    } = this.getTemplates();
    return {
      FakeEmail,
      currentTemplate: '',
      emailSend: false,
      openFullSizeMenu: false,
      newMailSubject: null,
      openMenu: false,
      textValue: 'Compensation',
      team_members: [],
      openDialog: false,
      showSuccessSnackbar: false,
      contactButtonLoading: false,
      emailBodyText: '',
      isScheduleSet: false,
      scheduleDate: null,
      scheduleTime: null,
      currentCandidateManualOutreach: false,
      tooltipCopy: false,
      isFirstTimeEmailSender: false,
      index: 0,
      sending: false,
      required,
      WarningIcon,
      inmailSuccessSnackBar: false,
      threadToggle: 0,
      invitationSuccessSnackBar: false,
      inmailErrorSnackBar: false,
      invitationErrorSnackBar: false,
      notFoundEmailErrorSnackBar: false,
      emailSuccessSnackBar: false,
      emailErrorSnackBar: false,
      unauthorizedSnackbar: false,
      emailSymbolErrorSnackBar: false,
      foundEmailSuccessSnackBar: false,
      foundEmailNumber: 0,
      contactOnLinkedin: false,
      loginErrorSnackBar: false,
      manualOutreachMap: {},
      visitedLinkedinMap: {},
      sender: localStorage.getItem('email'),
      allReceivers: [NO_DATA_AVAILABLE],
      calendar_user: localStorage.getItem('email'),
      textareaHeight: 419,
      needsEmailConfirmation,
      foundEmails: false,
      EditEmailIcon,
      showAuthenticationModal: false,
      loading: false,
      listTitle: 'Choose a message type',
      dropdownActiveItemId: 1,
      markingAsContacted: false,
      debouncedSubject: debounce(this.setMailData, 400),
      debouncedTemplate: debounce(this.setMailData, 400),
      debouncedHeightCounter: debounce(this.textareaHeightCounter, 400),
      PauseIcon,
      PlayIcon,
      linkedinLogin: {
        username: '',
        password: '',
      },

      li_session_id: '',
      verifyCode: '',

      linkedinDialog: {
        signin: false,
        twoStep: false,
        success: false,
        error: false,

        signinLoading: false,
        twoStepLoading: false,

        width: 570,
      },

      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline'],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' },
        ],
        [{ header: 1 }, { header: 2 }],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [{ indent: '-1' }, { indent: '+1' }],
      ],

      compensation_template,
      remote_template,
      visa_template,
      info_request_template,
      editEmail: false,
      inputEmail: '',
      showEmailSuccessSnackbar: false,
      emailRules,
      emailLoading: false,
      snackbar: false,
      alertMessage: '',
      availableReceivers: [],
      receiver: '',
      isFullGranted: false,
      scope: 'gmail.send',
      isCalendarProcess: false,
      disabledSend: false,
      infoIcon,
      isOutreachTemplateButtonsOpen: false,
      boltIcon,
      LinkedIcon,
      isAddLink: false,
      selectedText: '',
      selectedLink: '',
      dynamicPosition: {},
      frontStr: '',
      backStr: '',
      additionalInformation: '',
    };
  },

  computed: {
    candidateEmails() {
      const personalEmails = this.currentCandidate?.personal_emails ?? [];
      const profEmails = this.currentCandidate?.prof_emails ?? [];
      return [...personalEmails, ...profEmails];
    },

    updateEmailRules() {
      return [
        ...emailRules,
        (val) => {
          return !this.candidateEmails.includes(val)
            ? true
            : 'This email already exists.';
        },
      ];
    },

    quickAnswers() {
      const answers = [
        { name: 'Compensation', text: 'Compensation' },
        { name: 'Remote Work Policy', text: 'Remote Work Policy' },
        { name: 'Visa Sponsorship', text: 'Visa Sponsorship' },
        { name: 'Attach Resume', text: 'Attach Resume' },
      ];
      const hiringCompany =
        this.currentProjectSettings.hiring_company?.toLowerCase();
      if (hiringCompany.includes('zendesk') && this.isAdminView) {
        answers.push({
          name: 'Additional Information',
          text: 'Additional Information',
        });
      }

      return answers;
    },

    templates() {
      const templates = [];
      this.currentCandidateOutreachTemplates.forEach((item) => {
        templates.push(item.name ? item.name : '');
      });

      return templates;
    },

    outreachSender() {
      const email = this.currentCandidateEmailHistory[0]
        ? this.currentCandidateEmailHistory[0].from_email
        : '';
      return email || 'Hirefly';
    },

    dropdownActiveItem() {
      return (
        this.dropdownItems.find((e) => e.id === this.dropdownActiveItemId) || {}
      );
    },

    projects() {
      return this.$store.getters['projects/listProjects'];
    },

    currentProject() {
      if (!this.projectId) {
        return {};
      }

      return (
        this.projects.find(
          (project) => project.project_id === this.projectId
        ) || {}
      );
    },

    currentCandidateOutreachTemplates() {
      if (!this.currentCandidate.outreach_templates) {
        return [];
      }
      if (Array.isArray(this.currentCandidate.outreach_templates)) {
        return this.currentCandidate.outreach_templates;
      }
      return [this.currentCandidate.outreach_templates];
    },

    isValid() {
      return this.emailBodyText !== '';
    },

    isSelectedInvitation() {
      return this.dropdownActiveItem.listElement === 'LinkedIn Invitation';
    },

    isSelectedInMail() {
      return this.dropdownActiveItem.listElement === 'LinkedIn InMail';
    },

    isUserChanged() {
      return this.currentCandidateManualOutreach;
    },

    isSelectedEmail() {
      return this.dropdownActiveItem.listElement === 'Email';
    },

    isSelectedContactManually() {
      return this.dropdownActiveItem.listElement === 'Contact on my own';
    },

    isDisableClick() {
      return (
        (this.isSelectedInvitation &&
          this.selectedTemplate &&
          this.selectedTemplate.length > 300) ||
        (this.isSelectedEmail &&
          !this.receiver &&
          !this.needsEmailConfirmation &&
          (this.currentProject.needs_email_confirmation || // TODO(jeremiah): delete this line after v2 rollout
            this.currentProject.confirm_email_before_send))
      );
    },

    showSelection() {
      return this.getCount > 1;
    },

    currentCandidate() {
      if (!this.candidates) {
        return {};
      }
      const candidate = this.candidates[this.getIndex()] ?? {};
      return candidate;
    },

    currentCandidateEmailHistory() {
      if (!this.currentCandidate) {
        return [];
      }
      return this.currentCandidate.email_history || [];
    },

    getCount() {
      return this.candidates ? this.candidates.length : 0;
    },

    isV2() {
      return this.$store.getters['user/getIsUserV2'];
    },

    availableSenders() {
      if (this.isV2) {
        return this.currentProjectSettings.collaborators
          ? this.currentProjectSettings.collaborators.map(
              (collaborator) => collaborator.email
            )
          : [];
      }
      if (this.currentCandidate && this.currentCandidate.outreach_templates) {
        return this.currentCandidateOutreachTemplates.map(
          (template) => template.user_email
        );
      }
      return [];
    },

    UTCScheduledDate() {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const dateObj = new Date(`${this.scheduleDate} ${this.scheduleTime}`);
      const hours =
        dateObj.getUTCHours() < 10
          ? `0${dateObj.getUTCHours()}`
          : dateObj.getUTCHours();
      const mins =
        dateObj.getUTCMinutes() === 0 ? '00' : dateObj.getUTCMinutes();
      return `${this.scheduleDate} ${hours}:${mins}`;
    },

    avalableCollaborators() {
      const team_members_emails = [];
      for (let i = 0; i < this.collaborators.length; i++) {
        team_members_emails.push(this.collaborators[i].email);
      }
      return team_members_emails;
    },

    selectedSubject: {
      get() {
        if (!Array.isArray(this.currentCandidate.outreach_templates)) return '';

        const [first] = this.currentCandidate.outreach_templates.filter(
          (template) => template.name === this.currentTemplate
        );
        if (first === undefined) return '';
        return first.initial_outreach_subject;
      },

      set(v) {
        this.debouncedSubject(v, 'initial_outreach_subject');
        this.debouncedHeightCounter();
      },
    },

    selectedTemplate: {
      get() {
        if (!Array.isArray(this.currentCandidate.outreach_templates)) return '';

        const [first] = this.currentCandidate.outreach_templates.filter(
          (template) => template.name === this.currentTemplate
        );
        if (first === undefined) return '';
        const template = first[this.dropdownActiveItem.field];
        return this.maybeInsertSenderName(template);
      },

      set(v) {
        this.debouncedTemplate(v, this.dropdownActiveItem.field);
      },
    },

    preferredTemplateName() {
      return this.$store.getters['sessionPreferences/getPreferredTemplateName'](
        this.projectId
      );
    },

    outreachToggle() {
      return (
        this.currentProjectSettings.outreach_toggle || this.dropdownItems[0].id
      );
    },

    dropdownItems() {
      const emailsCount =
        this.availableReceivers &&
        this.availableReceivers.length &&
        this.availableReceivers[0] !== NO_DATA_AVAILABLE
          ? this.availableReceivers.length
          : 0;
      const approveText =
        this.tab.toUpperCase() === 'APPROVED'
          ? 'Send Email'
          : 'Approve & \n\n\n Send Email';
      return [
        {
          id: 1,
          itemTitle:
            !this.needsEmailConfirmation || emailsCount
              ? approveText
              : 'Find Email Addresses',

          listElement: 'Email',
          field: 'initial_outreach_template',
          disabled: this.currentCandidateManualOutreach,
        },
        {
          id: 2,
          itemTitle: 'Approve & Send InMail',
          listElement: 'LinkedIn InMail',
          field: 'initial_outreach_template',
        },
        {
          id: 3,
          itemTitle: 'Approve & Send Invitation',
          listElement: 'LinkedIn Invitation',
          field: 'li_connection_template',
        },
        {
          id: 4,
          itemTitle: 'Approve & Contact Myself',
          listElement: 'Contact on my own',
          field: 'initial_outreach_template',
        },
      ];
    },

    user() {
      return this.$store.getters['user/getUser'];
    },

    collaborators() {
      return this.currentProjectSettings.collaborators || [];
    },

    currentProjectSettings() {
      if (!this.projectId) {
        return {};
      }

      return this.$store.getters['projects/settings/getSettingsByProjectId'](
        this.projectId
      );
    },

    isValidEmail() {
      return this.emailRules.every((cb) => cb(this.inputEmail) === true);
    },

    isDisabledEdit() {
      return this.currentCandidate && !this.currentCandidate._id;
    },

    isAutopilot() {
      return (
        this.currentProject.in_auto_swipe_mode || // TODO(jeremiah): delete this line after v2 rollout
        this.currentProject.type === '1' ||
        this.currentProject.type === '3'
      );
    },

    isSyncCalendar() {
      return (
        this.currentProjectSettings.interview_scheduling ===
          'HIREFLY_SCHEDULING' &&
        this.currentProjectSettings.scheduling_preferences &&
        this.currentProjectSettings.scheduling_preferences
          .phone_screener_email &&
        this.currentProjectSettings.scheduling_preferences
          .phone_screener_email === localStorage.getItem('email')
      );
    },

    isRecruiter() {
      return (
        this.currentProject.is_warmleads_recruiter || // TODO(jeremiah): delete this after v2 migration
        this.currentProject.is_autopilot_recruiter
      );
    },

    selectedSenderFirstname() {
      if (
        !this.currentProjectSettings ||
        !this.currentProjectSettings.collaborators
      )
        return '';
      const match = this.currentProjectSettings.collaborators.filter(
        (collaborator) => collaborator.email === this.sender
      );
      return match.length > 0 ? match[0].name.split(' ')[0] : '';
    },

    isAdminView() {
      return this.user.is_super_admin;
    },
  },

  watch: {
    currentProject(v) {
      this.needsEmailConfirmation = v
        ? v.needs_email_confirmation || // TODO(jeremiah): delete this line after v2 migration
          v.confirm_email_before_send
        : false;
      if (
        this.currentCandidate &&
        this.currentCandidate.outreach_templates &&
        this.currentCandidate.outreach_templates.length
      ) {
        const [first] = this.currentCandidate.outreach_templates.filter(
          (template) => template.user_email === this.sender
        );
        this.receiver = first ? this.availableReceivers[0] : '';
      }
    },

    isSyncCalendar(v) {
      if (v) {
        this.getUserInfo();
      }
    },

    user() {
      const isSelfServe = this.$store.getters['user/getIsUserSelfServe'];
      if (
        this.user.onboarding_tours &&
        !this.user.onboarding_tours.self_serve_send_email &&
        isSelfServe
      ) {
        this.isFirstTimeEmailSender = true;
      }
    },

    isUserChanged() {
      this.dropdownActiveItemId = this.outreachToggle;
    },

    currentCandidate() {
      if (this.templates) {
        if (
          this.preferredTemplateName &&
          this.templates.includes(this.preferredTemplateName)
        ) {
          this.currentTemplate = this.preferredTemplateName;
        } else {
          this.currentTemplate = this.templates[0];
        }
      }
      this.currentCandidateManualOutreach =
        this.currentCandidate && this.currentCandidate.manual_outreach;
      this.availableReceivers =
        this.currentCandidate && this.currentCandidate.candidate_emails
          ? this.currentCandidate.candidate_emails
          : [NO_DATA_AVAILABLE];
      this.needsEmailConfirmation =
        this.currentProject.needs_email_confirmation || // TODO(jeremiah): delete this line after v2 migration
        this.currentProject.confirm_email_before_send;
      this.setAdditionalInformation();
    },

    currentCandidateEmailHistory() {
      this.threadToggle = 0;
      if (
        this.currentCandidateEmailHistory &&
        this.currentCandidateEmailHistory.length > 1
      ) {
        this.threadToggle = this.currentCandidateEmailHistory.length - 1;
      }

      setTimeout(() => {
        const container = this.$refs.threads;
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      }, 500);
    },

    isSelectedInvitation(v) {
      // if (!v) {
      this.sender = localStorage.getItem('email');
      this.debouncedHeightCounter();
      // }
    },

    isSelectedInMail(v) {
      // if (!v) {
      this.sender = localStorage.getItem('email');
      this.debouncedHeightCounter();
      // }
    },

    isSelectedContactManually(v) {
      this.sender = localStorage.getItem('email');
      this.debouncedHeightCounter();
    },

    candidates() {
      this.dropdownActiveItemId = this.outreachToggle;
    },

    currentProjectSettings() {
      const templates = this.getTemplates();
      this.compensation_template = templates.compensation_template;
      this.remote_template = templates.remote_template;
      this.visa_template = templates.visa_template;
      this.info_request_template = templates.info_request_template;
    },

    currentTemplate() {
      this.$store.commit('sessionPreferences/SET_PREFERRED_TEMPLATE', {
        projectId: this.projectId,
        templateName: this.currentTemplate,
      });
    },

    editEmail() {
      this.$nextTick(() => {
        this.$refs.form?.reset();
      });
    },
  },

  mounted() {
    setTimeout(() => {
      const container = this.$refs.thread;
      if (container) {
        container.scrollTop = container.scrollHeight;
      }
    }, 1250);
    this.dropdownActiveItemId = this.outreachToggle;
    this.currentCandidateManualOutreach =
      (this.currentCandidate && this.currentCandidate.manual_outreach) || false;
    this.textareaHeightCounter();

    this.updateShortcutTemplates();

    if (this.templates) {
      if (
        this.preferredTemplateName &&
        this.templates.includes(this.preferredTemplateName)
      ) {
        this.currentTemplate = this.preferredTemplateName;
      } else {
        this.currentTemplate = this.templates[0];
      }
    }

    this.availableReceivers =
      this.currentCandidate && this.currentCandidate.candidate_emails
        ? this.currentCandidate.candidate_emails
        : [NO_DATA_AVAILABLE];
    this.needsEmailConfirmation =
      this.currentProject.needs_email_confirmation || // TODO(jeremiah): delete this line after v2 migration
      this.currentProject.confirm_email_before_send;
    if (
      this.currentCandidate &&
      this.currentCandidate.outreach_templates &&
      this.currentCandidate.outreach_templates.length
    ) {
      const [first] = this.currentCandidate.outreach_templates.filter(
        (template) => template.user_email === this.sender
      );
      this.receiver = first ? this.availableReceivers[0] : '';
    }
    if (this.isSyncCalendar) {
      this.getUserInfo();
    }
    this.setAdditionalInformation();
    window.addEventListener('click', this.checkLinkClick, true);
  },

  unmounted() {
    window.removeEventListener('click', this.checkLinkClick, true);
  },

  created() {
    this.$root.$refs.sendMail = this;
    setTimeout(() => {
      if (
        this.currentCandidateEmailHistory &&
        this.currentCandidateEmailHistory !== null
      ) {
        this.threadToggle = this.currentCandidateEmailHistory.length - 1;
      }
    }, 500);
  },

  methods: {
    setAdditionalInformation() {
      this.additionalInformation = `Hi, \n\nThanks for your interest! Zendesk requires all applicants to self-identify as part of their equal employment opportunity practices. Could you please fill out <a href="${Config.env.REDIRECT_URI}/v1/candidates/additional_information?candidate_id=${this.currentCandidate?._id}" target="_blank">this 30 second survey</a> and then email me back when you're done? Looking forward to getting you in front of Zendesk's hiring team!`;
    },

    cancelAuth() {
      this.showAuthenticationModal = false;
    },

    onNextLogin() {
      this.isFullGranted = false;
      this.showAuthenticationModal = false;
      if (!this.isV2) {
        // keep same function in v1
        this.sendInMail();
        this.$emit('unselectCandidate', this.currentCandidate);
      } else {
        this.approveAndSend(this.dropdownActiveItemId);
      }
    },

    async getUserInfo() {
      this.scope = 'calendar';
      try {
        this.isFullGranted = false;
        const response = await get(`${Config.env.API_URL}users/scope_check`);
        this.isFullGranted = !response.data.calendar;
      } catch (e) {
        console.log(e);
      }
    },

    openSnackbar(e) {
      this.snackbar = true;
      this.alertMessage = e;
    },

    updateShortcutTemplates() {
      const templates = this.getTemplates();
      this.compensation_template = templates.compensation_template;
      this.remote_template = templates.remote_template;
      this.visa_template = templates.visa_template;
      this.info_request_template = templates.info_request_template;
    },

    removeTrackingCode(str) {
      let text = str;
      if (text && text.includes('[tracking]')) {
        const ind = text.indexOf('[ Click here to unsubscribe');
        if (ind > 0) text = text.substring(0, ind);
        const ind3 = text.indexOf('[Click here to unsubscribe');
        if (ind3 > 0) text = text.substring(0, ind3);
        const ind2 = text.indexOf('![tracking]');
        if (ind2 > 0) text = text.substring(0, ind2);
      }
      return text;
    },

    async updateEmail() {
      const isValid = this.$refs.form.validate();
      if (!isValid) {
        return;
      }

      this.emailLoading = true;
      try {
        const res = await put(`${Config.env.API_URL}candidates`, {
          candidate_id: this.currentCandidate._id,
          updated_candidate_email: this.inputEmail,
        });
        if (res.status === 200) {
          this.showEmailSuccessSnackbar = true;
          this.editEmail = false;
          this.$store.dispatch('projects/candidates/loadCandidates', {
            projectId: this.projectId,
            tab: this.tab,
            force: true,
            id: this.currentCandidate._id,
          });
        }
        this.emailLoading = false;
      } catch (e) {
        this.emailLoading = false;
      }
      this.emailLoading = false;
    },

    isHireflyMessage(i) {
      let isHirefly = false;
      this.collaborators.forEach((collaborator) => {
        if (
          collaborator.email === this.currentCandidateEmailHistory[i].from_email
        ) {
          isHirefly = true;
        }
      });
      return isHirefly;
    },

    openModalWithEnter(e) {
      if (e.metaKey || e.ctrlKey) {
        if (this.isValid) {
          this.emailSend = true;
        }
      }
    },

    sendWithEnter(e) {
      if (e.metaKey || e.ctrlKey) {
        this.approveAndSend(this.dropdownActiveItemId);
      }
    },

    getTemplates() {
      if (!this.currentProjectSettings) return {};
      if (this.currentProjectSettings.autopilot_templates) {
        const templates = this.currentProjectSettings.autopilot_templates;
        return {
          compensation_template: templates.compensation_template || '',
          remote_template: templates.remote_work_template || '',
          visa_template: templates.visa_template || '',
          info_request_template: templates.info_request_template || '',
        };
      }
      // TODO(jeremiah): clean up this section after v2 rollout
      const compensation_template =
        this.currentProjectSettings.compensation_template || '';
      const remote_template = this.currentProjectSettings.remote_template || '';
      const visa_template = this.currentProjectSettings.visa_template || '';
      const info_request_template =
        this.currentProjectSettings.info_request_template || '';
      return {
        compensation_template,
        remote_template,
        visa_template,
        info_request_template,
      };
    },

    replaceWithLinks(str) {
      if (!str) return '';
      let text = this.removeTrackingCode(str);
      const urlRegex = /\((https?:\/\/[^\s]+)/g;
      if (text.match(urlRegex)) {
        // eslint-disable-next-line no-unreachable-loop, guard-for-in
        for (const i in text.match(urlRegex)) {
          text = text.replace(
            /\[(.+?)\]/g,
            `<a target="_blank" style="color: #111827; font-weight: 600" href="${
              (text.replace(urlRegex),
              text.match(urlRegex)[i].replaceAll(/\(+(.*?)\)+/g, '$1'))
            }">$1</a>`
          );
          // eslint-disable-next-line no-useless-escape
          text = text.replace(/\>\((https?:\/\/[^\s]+)/g, '>');
          return text;
        }
      }
      return text;
    },

    saveTemplate() {
      switch (this.textValue) {
        case 'Compensation':
          this.updateProject({
            compensation_template: this.compensation_template,
          });
          break;
        case 'Remote Work Policy':
          this.updateProject({
            remote_template: this.remote_template,
          });
          break;
        case 'Visa Sponsorship':
          this.updateProject({
            visa_template: this.visa_template,
          });
          break;
        case 'Attach Resume':
          this.updateProject({
            info_request_template: this.info_request_template,
          });
          break;
        default:
          break;
      }
    },

    async updateProject(project) {
      await this.$store.dispatch('projects/settings/updateProject', {
        projectId: this.projectId,
        project,
        settingsOnly: true,
      });
    },

    insertEmail() {
      switch (this.textValue) {
        case 'Compensation':
          this.emailBodyText += this.compensation_template;
          break;
        case 'Remote Work Policy':
          this.emailBodyText += this.remote_template;
          break;
        case 'Visa Sponsorship':
          this.emailBodyText += this.visa_template;
          break;
        case 'Attach Resume':
          this.emailBodyText += this.info_request_template;
          break;
        case 'Additional Information':
          this.emailBodyText += `<p>${this.additionalInformation}</p>`;
          break;
        default:
          break;
      }

      this.openMenu = false;
      this.openFullSizeMenu = false;
      this.saveTemplate();
    },

    setDropdownEmailClick(state) {
      this.$set(this.dropdownItems, '0', {
        ...this.dropdownItems[0],
        disabled: state,
      });
    },

    contactCandidate() {
      let links = convertEmailTemplate(this.emailBodyText);
      links = links.replaceAll('\n\n', '<br />');
      links = links.replaceAll('\n', '<br />');
      const session = localStorage.getItem('session');
      axios.defaults.headers.post['X-Parse-Session-Token'] = session;
      this.contactButtonLoading = true;
      const emailSubjectFromHistory =
        this.currentCandidateEmailHistory &&
        this.currentCandidateEmailHistory[0]
          ? this.currentCandidateEmailHistory[0].email_subject
          : '';
      const emailSubject =
        this.newMailSubject !== null
          ? this.newMailSubject
          : emailSubjectFromHistory;
      // TODO(jeremiah): clean this up after v2 migration
      let apiUrl;
      if (this.isV2) {
        apiUrl = `${Config.env.API_URL_V2}projects/candidates/email`;
      } else {
        apiUrl = `${Config.env.API_URL}email`;
      }
      const candidate_id = this.currentCandidate.core_candidate_id
        ? this.currentCandidate.core_candidate_id
        : this.currentCandidate._id;
      axios
        .post(apiUrl, {
          to_email: this.currentCandidate.thread_email, // TODO(jeremiah): delete this line after v2 migration
          email_override: this.currentCandidate.thread_email,
          email_subject: emailSubject || '',
          email_body: links.trim(),
          thread_id: this.currentCandidate.thread_id
            ? this.currentCandidate.thread_id
            : '',
          cc_email: this.team_members.join(','),
          candidate_id,
          email_type: 'candidate_autopilot_response',
        })
        .then((data) => {
          this.emailSend = false;
          this.showSuccessSnackbar = true;
          if (
            this.tab === 'WARM_LEADS_QUESTION' ||
            (this.tab === 'WARM_LEADS_RECRUITER' && this.isRecruiter)
          ) {
            this.setCandidateStatus(
              this.currentCandidate.id,
              'WARM_LEADS_AWAITING_INFO'
            );
          }
          if (this.tab === 'QUESTION') {
            this.setCandidateStatus(this.currentCandidate.id, 'AWAITING_INFO');
          }
          if (
            this.currentCandidateEmailHistory &&
            this.currentCandidateEmailHistory.length
          ) {
            const history = this.currentCandidate.email_history.push({
              from_email: this.currentCandidateEmailHistory[0]
                ? this.currentCandidateEmailHistory[0].from_email
                : '',
              date: moment().format('llll'),
              email_subject: this.currentCandidateEmailHistory
                ? this.currentCandidateEmailHistory[0].email_subject
                : '',
              email_body: links.trim(),
              thread_id: this.currentCandidate.thread_id
                ? this.currentCandidate.thread_id
                : '',
            });
            this.$store.dispatch(
              'projects/candidates/updateCandidateEmailHistory',
              { history }
            );
          } else {
            this.$store.dispatch('projects/candidates/loadCandidates', {
              projectId: this.projectId,
              tab: this.tab,
              force: true,
              id: this.currentCandidate._id,
            });
          }
          this.emailBodyText = '';
        })
        .then(() => {
          this.contactButtonLoading = false;
        })
        .catch((error) => {
          this.contactButtonLoading = false;
        });
    },

    maybeShowEmailTooltip() {
      if (this.isFirstTimeEmailSender) {
        this.tooltipCopy = true;
        this.isFirstTimeEmailSender = false;
        this.handleTourFinished();
      }
    },

    async handleTourFinished() {
      const { onboarding_tours } = this.user || {};
      onboarding_tours.self_serve_send_email = true;
      await put(`${Config.env.API_URL}users/settings`, {
        onboarding_tours,
      });
    },

    textareaHeightCounter() {
      const subjectFieldHeight =
        this.$refs.subject && this.$refs.subject.$el.offsetHeight;
      const isNumber = typeof subjectFieldHeight === 'number';

      this.textareaHeight = isNumber
        ? subjectFieldHeight + 320
        : this.textareaHeight;
    },

    expandThread(index) {
      if (this.threadToggle === index) {
        this.threadToggle = -1;
      } else {
        this.threadToggle = index;
      }
    },

    async verifyLinkedin() {
      if (!this.verifyCode) return;

      try {
        this.linkedinDialog.twoStepLoading = true;
        const res = await put(`${Config.env.API_URL}li/login`, {
          li_session_id: this.li_session_id,
          twofac_key: this.verifyCode,
        });

        if (res.status === 200) {
          this.showPopupByName('success');
        }
      } catch (e) {
        console.error(e.message);
        this.loginErrorSnackBar = true;
        this.showPopupByName('error');
        return;
      } finally {
        this.linkedinDialog.twoStepLoading = false;
      }
    },

    async signinLinkedin() {
      const { username, password } = this.linkedinLogin;

      if (!username || !password) {
        return;
      }

      try {
        this.linkedinDialog.signinLoading = true;
        const res = await post(`${Config.env.API_URL}li/login`, {
          username,
          password,
        });
        if (res.status === 200) {
          // Successfull login
          this.showPopupByName('success');
        } else if (res.status === 202) {
          this.li_session_id = res.data;
          // Needed two factor authentication
          this.showPopupByName('twoStep');
        }
      } catch (e) {
        this.loginErrorSnackBar = true;
        this.showPopupByName('error');
        console.error(e);
      } finally {
        this.linkedinDialog.signinLoading = false;
      }
    },

    setMailData(v, field) {
      if (!Array.isArray(this.currentCandidate.outreach_templates)) return;

      const isFirstTime = true;
      const jsonCurrentCandidate = JSON.stringify(this.currentCandidate);
      const currentCandidateCopy = isJSON(jsonCurrentCandidate)
        ? JSON.parse(jsonCurrentCandidate)
        : null;

      if (currentCandidateCopy === null) {
        console.error('"currentCandidateCopy" is null');
        return;
      }

      const value = currentCandidateCopy.outreach_templates.map((e) => {
        const template = e;
        if (template.name === this.currentTemplate) {
          template[field] = v;
        }

        return template;
      });

      this.$store.commit('projects/candidates/UPDATE_CANDIDATE', {
        candidate: this.currentCandidate,
        field: 'outreach_templates',
        value,
      });
    },

    maybeInsertSenderName(template) {
      const templateCopy = template;
      if (
        this.currentProject.type !== 'NAVIGATOR' &&
        this.currentProject.type !== '2'
      ) {
        return templateCopy;
      }
      return templateCopy.replace(
        '{sender firstname}',
        this.selectedSenderFirstname
      );
    },

    showPopupByName(popup) {
      this.closeAllPopups();
      this.linkedinDialog[popup] = true;
    },

    closeAllPopups() {
      const popups = ['signin', 'twoStep', 'success', 'error'];
      popups.forEach((p) => (this.linkedinDialog[p] = false));
    },

    async sendMail(tab) {
      this.$emit('loading2', true);
      const links = convertEmailTemplate(this.selectedTemplate);

      const requestData = {
        email_sender: this.sender,
        calendar_user: this.calendar_user,
        candidate_id: this.currentCandidate._id,
        project_id: this.projectId,
        email_subject: this.selectedSubject,
        email_body: links.trim(),
        type: 'candidate_navigator_response',
      };
      if (this.scheduleDate && this.scheduleTime && this.isScheduleSet) {
        requestData.scheduled_date = this.UTCScheduledDate;
      }
      this.$amplitude_client.logEvent({
        event_type: 'approve_and_send_message_fe',
        user_id: localStorage.getItem('email'),
        event_properties: requestData,
      });

      try {
        const response = await post(
          `${Config.env.API_URL}email/find`,
          requestData
        );

        if (response && response.status === 200) {
          consola.info('Found email address');
          this.emailSuccessSnackBar = true;
          this.setCandidateStatus(this.currentCandidate._id, 'CONTACTED', tab);
          this.loading = false;
          this.$emit('loading2', false);
          return true;
        }
      } catch (e) {
        if (e.response && e.response.status === 404) {
          this.$store.commit('projects/candidates/UPDATE_CANDIDATE', {
            candidate: this.candidates[this.index],
            field: 'manual_outreach',
            value: true,
          });
          this.currentCandidateManualOutreach = true;
        }

        consola.info("Couldn't find email address");
        this.sending = false;
        this.emailErrorSnackBar = true;
        this.contactOnLinkedin = true;
        Vue.set(this.manualOutreachMap, this.currentCandidate._id, true);
        this.loading = false;
        this.$emit('loading2', false);
      } finally {
        this.loading = false;
        this.$emit('loading2', false);
      }
      return false;
    },

    async sendInMail() {
      let links = convertEmailTemplate(this.selectedTemplate);
      links = convertEmailTemplateForLinkedIn(links);
      const requestData = {
        candidate_id: this.currentCandidate._id,
        project_id: this.projectId,
        message_subject: this.selectedSubject,
        message_body: links.trim(),
      };
      if (this.scheduleDate && this.scheduleTime && this.isScheduleSet) {
        requestData.scheduled_date = this.UTCScheduledDate;
      }
      this.$amplitude_client.logEvent({
        event_type: 'approve_and_send_inmail_fe',
        user_id: localStorage.getItem('email'),
        event_properties: requestData,
      });

      try {
        const response = await post(
          `${Config.env.API_URL}li/inmail`,
          requestData
        );

        if (response && (response.status === 200 || response.status === 202)) {
          this.inmailSuccessSnackBar = true;
          this.setCandidateStatus(this.currentCandidate._id, 'CONTACTED');
        }
      } catch (e) {
        if (e.response.status === 403) {
          this.showPopupByName('signin');
          return;
        }

        this.inmailErrorSnackBar = true;
        console.error('Error <sendInMail> -> ', e.response);
      } finally {
        this.loading = false;
      }
    },

    async findMail() {
      const { candidate_emails = [] } = this.currentCandidate || {};
      this.foundEmails = candidate_emails.length !== 0;
      const requestData = {
        email_sender: this.sender,
        calendar_user: this.calendar_user,
        candidate_id: this.currentCandidate._id,
        project_id: this.projectId,
        email_subject: this.selectedSubject,
        email_body: this.selectedTemplate,
        send_confirmed: false,
      };
      if (this.foundEmails) {
        requestData.send_confirmed = true;
        requestData.email_override = this.receiver;
      }
      if (this.scheduleDate && this.scheduleTime && this.isScheduleSet) {
        requestData.scheduled_date = this.UTCScheduledDate;
      }
      try {
        const response = await post(
          `${Config.env.API_URL}email/find`,
          requestData
        );
        if (response && (response.status === 200 || response.status === 202)) {
          if (!this.foundEmails) {
            this.allReceivers = response.data;
            this.$store.commit('projects/candidates/UPDATE_CANDIDATE', {
              candidate: this.candidates[this.index],
              field: 'candidate_emails',
              value: response.data,
            });
            if (this.allReceivers && this.allReceivers.length) {
              this.$refs.mailTo.isMenuActive = true;
              this.foundEmailSuccessSnackBar = true;
              this.foundEmailNumber = this.allReceivers.length;
              this.receiver = this.allReceivers[0];
              // this.dropdownItems[0].itemTitle = 'Approve & \n\n\n Send Email';
              this.foundEmails = true;
            }
          } else {
            this.emailSuccessSnackBar = true;
            this.markAsContacted();
            this.foundEmails = false;
          }
          // this.inmailSuccessSnackBar = true
          // this.setCandidateStatus(this.currentCandidate._id, 'CONTACTED')
        }
      } catch (e) {
        if (!e.response) return;
        if (e.response.status === 404) {
          // this.showPopupByName('signin')
          if (!this.foundEmails) {
            this.allReceivers = [NO_FOUND_EMAIL_TEXT];
            this.currentCandidateManualOutreach = true;
            this.notFoundEmailErrorSnackBar = true;
            this.needsEmailConfirmation = false;
            if (this.allReceivers && this.allReceivers.length) {
              this.receiver = this.allReceivers[0];
            }
          }
          return;
        }

        // this.inmailErrorSnackBar = true
        // console.error('Error <sendInMail> -> ', e.response)
      } finally {
        this.loading = false;
      }
    },

    async findMailV2() {
      const { candidate_emails = [] } = this.currentCandidate || {};
      this.foundEmails = candidate_emails.length !== 0;
      const candidateId = this.currentCandidate.core_candidate_id
        ? this.currentCandidate.core_candidate_id
        : this.currentCandidate._id;
      try {
        const response = await get(
          `${Config.env.API_URL_V2}projects/candidates/email?allow_work_emails=${this.currentProjectSettings.allow_work_emails}&candidate_id=${candidateId}`
        );

        if (response && (response.status === 200 || response.status === 202)) {
          if (!this.foundEmails) {
            this.allReceivers = response.data;
            this.availableReceivers = response.data;
            if (this.allReceivers && this.allReceivers.length) {
              this.currentCandidateManualOutreach = false;
              this.$refs.mailTo.isMenuActive = true;
              this.foundEmailSuccessSnackBar = true;
              this.foundEmailNumber = this.allReceivers.length;
              // this.dropdownItems[0].itemTitle = 'Approve & \n\n\n Send Email';
              this.foundEmails = true;
              this.receiver = '';
            }
          } else {
            this.emailSuccessSnackBar = true;
            this.foundEmails = false;
          }
          // this.inmailSuccessSnackBar = true
          // this.setCandidateStatus(this.currentCandidate._id, 'CONTACTED')
          this.needsEmailConfirmation = false;
        }

        // console.log('response <findInMail> -> ', response.data)
      } catch (e) {
        if (!e.response) return;
        if (e.response.status === 404) {
          // this.showPopupByName('signin')
          if (!this.foundEmails) {
            this.allReceivers = [NO_FOUND_EMAIL_TEXT];
            this.currentCandidateManualOutreach = true;
            this.notFoundEmailErrorSnackBar = true;
            this.needsEmailConfirmation = false;
            if (this.allReceivers && this.allReceivers.length) {
              this.receiver = this.allReceivers[0];
            }
          }
          return;
        }

        // this.inmailErrorSnackBar = true
        // console.error('Error <sendInMail> -> ', e.response)
      } finally {
        this.loading = false;
      }
    },

    async sendInvitation() {
      if (this.selectedTemplate && this.selectedTemplate.length > 300) {
        this.loading = false;
        this.emailSymbolErrorSnackBar = true;
        return;
      }

      let links = convertEmailTemplate(this.selectedTemplate);
      links = convertEmailTemplateForLinkedIn(links);
      const requestData = {
        candidate_id: this.currentCandidate._id,
        project_id: this.projectId,
        message_body: links.trim(),
      };
      if (this.scheduleDate && this.scheduleTime && this.isScheduleSet) {
        requestData.scheduled_date = this.UTCScheduledDate;
      }
      this.$amplitude_client.logEvent({
        event_type: 'approve_and_send_connection_fe',
        user_id: localStorage.getItem('email'),
        event_properties: requestData,
      });

      try {
        const response = await post(
          `${Config.env.API_URL}li/connect`,
          requestData
        );

        if (response && (response.status === 200 || response.status === 202)) {
          this.invitationSuccessSnackBar = true;
          this.setCandidateStatus(this.currentCandidate._id, 'CONTACTED');
        }
      } catch (e) {
        if (e.response.status === 403) {
          this.showPopupByName('signin');
          return;
        }
        this.setCandidateStatus(this.currentCandidate._id, 'APPROVED');
        this.invitationErrorSnackBar = true;
        console.error('Error: <sendInvitation> function', e.response);
      } finally {
        this.loading = false;
      }
    },

    async scheduleSet() {
      this.isScheduleSet = true;
      if (this.scheduleDate && this.scheduleTime && this.isScheduleSet) {
        this.approveAndSend(this.dropdownActiveItemId);
      }
    },

    async onDateChanged(value) {
      this.scheduleDate = moment(value).format('MMM DD, YYYY');
    },

    async onTimeChanged(value) {
      this.scheduleTime = value;
    },

    async approveAndSend(id) {
      try {
        this.loading = true;
        if (id === 1) {
          if (this.needsEmailConfirmation) {
            // TODO(jeremiah): clean this up after v2 rollout
            if (this.isV2) {
              await this.findMailV2();
            } else {
              await this.findMail();
            }
          } else {
            if (this.isFullGranted) {
              this.isCalendarProcess = true;
              return;
            }
            this.scope = 'gmail.send';
            const response = await get(
              `${Config.env.API_URL}users/scope_check`
            );
            if (!response.data.email_send) {
              this.showAuthenticationModal = true;
              return;
            }

            // TODO(jeremiah): clean this up after v2 rollout
            if (this.isV2) {
              await this.approveAndSendV2();
            } else {
              await this.sendMail();
              this.$emit('unselectCandidate', this.currentCandidate);
            }
          }
        } else if (id === 2) {
          await this.sendInMail();
          this.$emit('unselectCandidate', this.currentCandidate);
        } else if (id === 3) {
          await this.sendInvitation();
          this.$emit('unselectCandidate', this.currentCandidate);
        } else if (id === 4) {
          await this.setCandidateStatus(this.currentCandidate._id, 'CONTACTED');
          this.$emit('unselectCandidate', this.currentCandidate);
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    async approveAndSendV2() {
      this.$emit('loading2', true);
      const links = convertEmailTemplate(this.selectedTemplate);
      const candidate_id = this.currentCandidate.core_candidate_id
        ? this.currentCandidate.core_candidate_id
        : this.currentCandidate._id;

      const requestData = {
        candidate_id,
        sender_override: this.sender,
        project_id: this.projectId,
        email_subject: this.selectedSubject,
        email_body: links.trim(),
        is_calibration: this.isCalibration,
        tab: this.tab,
        email_type: 'NAVIGATOR_INITIAL',
        candidateProjectId: this.currentCandidate.project_id,
      };
      if (
        this.currentProject.needs_email_confirmation || // TODO(jeremiah): delete this line after v2 rollout
        this.currentProject.confirm_email_before_send
      ) {
        requestData.email_override = this.receiver;
      }

      try {
        // Core candidate not yet associated with project
        const response = await this.$store.dispatch(
          'projects/candidates/approveAndSend',
          requestData
        );
        const { data } = response || {};
        const { email_status } = data || {};
        if (email_status === 200) {
          this.emailSuccessSnackBar = true;
          this.loading = false;
          this.$emit('loading2', false);
          this.$emit('unselectCandidate', this.currentCandidate);
          return true;
        }
        if (email_status === 404) {
          // TODO(jeremiah): update status to manual outreach
          this.currentCandidateManualOutreach = true;
          // disabled button
        }
        if (email_status === 401) {
          this.unauthorizedSnackbar = true;
          this.loading = false;
          this.$emit('loading2', false);
          this.$emit('unselectCandidate', this.currentCandidate);
          return true;
        }
        this.sending = false;
        this.emailErrorSnackBar = true;
        this.contactOnLinkedin = true;
        Vue.set(this.manualOutreachMap, this.currentCandidate._id, true);
        this.loading = false;
        this.$emit('loading2', false);
        return true;
      } catch (e) {
        if (e.response && e.response.status === 404) {
          // TODO(jeremiah): update status to manual outreach
          this.currentCandidateManualOutreach = true;
        }

        this.sending = false;
        this.emailErrorSnackBar = true;
        this.contactOnLinkedin = true;
        Vue.set(this.manualOutreachMap, this.currentCandidate._id, true);
        this.loading = false;
        this.$emit('loading2', false);
      } finally {
        this.loading = false;
        this.$emit('loading2', false);
      }
      return false;
    },

    async setCandidateStatus(candidateId, status, currentTab) {
      await this.$store.dispatch('projects/candidates/updateCandidateState', {
        projectId: this.projectId,
        tab: currentTab || this.tab,
        candidateId,
        newTab: status,
      });
    },

    handleEmailUpdate() {
      this.$emit('candidateUpdate', this.currentCandidate);
    },

    changeCurrentCandidate(c) {
      Vue.set(this.visitedLinkedinMap, this.currentCandidate._id, false);
      this.needsEmailConfirmation = !!this.$store.getters[
        'projects/getProjectById'
      ](this.projectId).needs_email_confirmation;
      this.index += c;
      this.dropdownActiveItemId = this.currentCandidate.manual_outreach ? 2 : 1;
    },

    getIndex() {
      if (this.index < 0) {
        this.index = 0;
      }
      if (this.index >= this.getCount) {
        this.index = this.getCount - 1;
      }
      return this.index;
    },

    async markAsContacted() {
      this.markingAsContacted = true;
      await this.setCandidateStatus(this.currentCandidate._id, 'CONTACTED');
      this.markingAsContacted = false;
      this.contactOnLinkedin = false;
      this.emailErrorSnackBar = false;
      this.emailSuccessSnackBar = false;
      this.$emit('unselectCandidate', this.currentCandidate);
    },

    async onDisableFollowups() {
      this.loading = true;
      try {
        await put(`${Config.env.API_URL}candidates`, {
          candidate_id: this.currentCandidate._id,
          disable_followups: !this.currentCandidate.disable_followups,
        });

        this.$store.dispatch('projects/candidates/loadCandidates', {
          projectId: this.projectId,
          tab: this.tab,
          force: true,
          id: this.currentCandidate._id,
        });
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    },

    profilePicture(history) {
      if (!history) return '';

      if (
        this.currentCandidate?.personal_emails?.includes(history.from_email)
      ) {
        return (
          this.currentCandidate?.profile_pic_url ??
          this.currentCandidate?.picture_url
        );
      }

      return `https://ui-avatars.com/api/?background=ffffff&color=384955&name=${history.from_email}`;
    },

    insertVariable(v) {
      const selection = document.getSelection();
      if (selection.focusNode.parentElement.closest('.insert-area')) {
        addTextToElement(v);
      } else {
        insertVariable.call(this, v, this.FIELDS);
      }
    },

    onCloseLink(old, data) {
      const ele = document.getElementById('insertLinkClass');
      if (ele && data) {
        if (ele.innerHTML.includes(old)) {
          ele.innerHTML = ele.innerHTML.replace(old, data);
        } else {
          ele.innerHTML = data;
        }

        ele.removeAttribute('id');
        if (ele.tagName === 'A') {
          ele.outerHTML = data;
        }
      } else if (ele) {
        ele.removeAttribute('id');
      }
      if (ele) ele.innerHTML = ele.innerHTML.replaceAll('*', '');

      this.isAddLink = false;
      this.selectedText = '';
      this.selectedLink = '';
      this.frontStr = '';
      this.backStr = '';
      this.dynamicPosition = '';
    },

    onAddLink(params) {
      const { text, link } = params;
      const str = link ? `<a href="${link}">${text}</a>` : text;
      const data = `${this.frontStr}${str}${this.backStr}`;

      this.onCloseLink(this.selectedStr, data);
    },

    onLink(isLink) {
      if (!isLink) this.dynamicPosition = '';
      this.onTextClick(isLink);
      this.isAddLink = true;
    },

    onTextClick(isLink) {
      const selection = document.getSelection();

      if (isLink) {
        this.selectedStr = this.selectedText;
        if (selection.focusNode.parentElement) {
          selection.focusNode.parentElement.id = 'insertLinkClass';
        }
        return;
      }

      if (
        selection &&
        selection.focusNode &&
        selection.focusNode.parentElement &&
        selection.focusNode.parentElement.closest('.insert-area')
      ) {
        const originalContent = selection.focusNode
          ? selection.focusNode.data
          : '';

        let originalStart = selection.baseOffset;
        let originalEnd = selection.extentOffset;
        this.selectedText = originalContent
          ? originalContent.substring(originalStart, originalEnd)
          : '';

        if (originalEnd < originalStart) {
          const tmp = originalEnd;
          originalEnd = originalStart;
          originalStart = tmp;
        }
        this.frontStr = originalContent
          ? originalContent.substring(0, originalStart)
          : '';
        this.backStr = originalContent
          ? originalContent.substring(originalEnd, originalContent.length)
          : '';

        this.selectedStr = originalContent;
        if (selection.focusNode.nodeName === '#text') {
          selection.focusNode.parentElement.id = 'insertLinkClass';
          if (selection.focusNode.parentElement.tagName === 'A') {
            this.selectedText = selection.focusNode.parentElement.innerHTML;
            this.selectedLink = selection.focusNode.parentElement.href;
          } else {
            selection.focusNode.data = originalContent?.replace(
              this.selectedText,
              `${this.selectedText}*`
            );
            this.selectedStr = originalContent?.replace(
              this.selectedText,
              `${this.selectedText}*`
            );
          }
        } else {
          selection.focusNode.id = 'insertLinkClass';
          if (selection.focusNode.tagName === 'A') {
            this.selectedText = selection.focusNode.innerHTML;
            this.selectedLink = selection.focusNode.href;
          } else {
            selection.focusNode.data = originalContent?.replace(
              this.selectedText,
              `${this.selectedText}*`
            );
            this.selectedStr = originalContent?.replace(
              this.selectedText,
              `${this.selectedText}*`
            );
          }
        }
      }
    },

    checkLinkClick(e) {
      if (
        e &&
        e.target &&
        e.target.closest('.insert-area') &&
        e.target.localName === 'a'
      ) {
        this.selectedText = e.target.innerHTML;
        this.selectedLink = e.target.href;
        this.dynamicPosition = `left:${e.target.offsetLeft + 24}px; top:${
          e.target.offsetTop + 300
        }px`;
        this.onLink(true);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables.scss';
@import './scss/tab.scss';
@import '../project/components/main.scss';

.dialog {
  padding: 36px 44px 60px;
  border-radius: 16px;
  background-color: white;

  .d-container {
    max-width: 222px;
    margin: 0 auto;
  }
  .dialog__close-btn {
    top: 13px;
    right: 25px;
  }
  .dialog__title {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.71px;
    text-align: center;
    color: $gray-dark;

    &.space-bottom {
      margin-bottom: 50px;
    }
  }
  .dialog__subtitle {
    font-size: 16px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.57px;
    text-align: center;
    color: $gray-dark;
  }
  .dialog__text {
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.43px;
    text-align: center;
    color: $gray-light;
  }
  .code-label {
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.57px;
    text-align: center;
    color: $gray-dark;
  }

  .dialog__button {
    .v-input {
      &::v-deep .v-input__slot {
        border-bottom: 1px solid rgba(0, 0, 0, 0.42);
      }
    }

    &::v-deep .v-btn__content {
      font-size: 18px;
      font-weight: 600;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: 0.64px;
      text-transform: initial;
    }
  }
  .dialog__text-field {
    &.field-code {
      &::v-deep .v-text-field__details {
        display: none;
      }
      &::v-deep input {
        padding-right: 0 !important;
        text-align: center;
      }
    }
    &::v-deep .v-input__slot {
      margin-bottom: 0;

      input {
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: 0.5px;
        color: $gray-dark;

        &::placeholder {
          color: $gray-light;
        }
      }
    }
  }

  .code-form__row {
    transform: translateX(-31px);
    margin-bottom: 65px;
  }
}

.mail-from-box,
.mail-template-box,
.mail-to-box {
  height: 30px;
}
.mail-from-box,
.mail-to-box,
.mail-template-box,
.mail-calendar-box {
  .v-input {
    &::v-deep .v-input__slot {
      width: 260px;
    }
    &::v-deep .v-input__control {
      border-bottom: 1px solid rgba(0, 0, 0, 0.42);
      height: 28px;
    }
  }
}
.mail-from-box::after {
  content: 'From:';
  position: absolute;
  bottom: 5px;
  font-size: 14px;
  color: #a1a5a6;
}
.mail-template-box::after {
  content: 'Template:';
  position: absolute;
  bottom: 5px;
  font-size: 14px;
  color: #a1a5a6;
}
.mail-to-box::after {
  content: 'To:';
  position: absolute;
  bottom: 5px;
  font-size: 14px;
  color: #a1a5a6;
}
.mail-cc-box::before {
  margin-top: 5px;
}
.cc_divider {
  margin-top: -12px !important;
}
.mail-from::v-deep .v-select__selection,
.v-input::v-deep input,
.email-textarea::v-deep textarea {
  font-size: 14px;
  color: $black;
}

.mail-template::v-deep .v-select__selection,
.v-input::v-deep input,
.email-textarea::v-deep textarea {
  font-size: 14px;
  color: $black;
}

.mail-cc::v-deep .v-select__selection,
.v-input::v-deep input,
.email-textarea::v-deep textarea {
  font-size: 11px;
  color: $gray-light;
}
.mail-cc::v-deep input {
  font-size: 11px !important;
  color: $gray-light;
}
.mail-to::v-deep .v-select__selection,
.v-input::v-deep input,
.email-textarea::v-deep textarea {
  font-size: 14px;
  color: $black;
}
.email-textarea {
  &::v-deep .ql-editor {
    font-size: 14px;
    color: $black;
    font-family: 'IBM Plex Sans', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    min-height: 215px;
    max-height: 215px;
  }
  &::v-deep .ql-container {
    padding: 10px 5px 50px 0;
    border: 1px solid #e6e7eb !important;
    border-radius: 4px;
  }
  &::v-deep .ql-toolbar {
    position: absolute;
    bottom: 0;
    width: calc(100% - 24px);
    border: none;
    border-top: 1px solid #e6e7eb !important;
    z-index: 2;
  }
}

.mail-template::v-deep .v-select__selection {
  margin-bottom: 0;
  padding-left: 65px;
}

.mail-from::v-deep .v-select__selection {
  margin-bottom: 0;
  padding-left: 50px;
}
.mail-to::v-deep .v-select__selection {
  margin-bottom: 0;
  padding-left: 50px;
}

.mail-calendar-box {
  height: 30px;
}
.mail-cc-box {
  width: 180px;
  margin-top: 1.5px;
}

.mail-calendar-box::after {
  content: 'Calendar:';
  position: absolute;
  bottom: 5px;
  left: 11px;
  font-size: 14px;
  color: #a1a5a6;
}
.mail-calendar::v-deep .v-select__selection,
.v-input::v-deep input,
.email-textarea::v-deep textarea {
  font-size: 14px;
  color: $black;
}

.mail-calendar::v-deep .v-select__selection {
  margin-bottom: 0;
  padding-left: 60px;
}

.v-input::v-deep input:not([readonly='readonly']) {
  padding-right: 26px !important;
}

.subject-textarea {
  &::v-deep textarea {
    height: 22px;
    max-height: 120px;
    font-size: 14px;
    line-height: 1.4;
    padding-top: 8px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.42);
    padding-left: 35px;
  }
}
.subject-textarea::after {
  content: 'Subj:';
  position: absolute;
  top: 8px;
  left: 11px;
  font-size: 14px;
  color: #a1a5a6;
}
.email-textarea {
  &::v-deep .v-text-field__slot {
    padding-bottom: 8px;
  }
  &::v-deep textarea {
    padding-right: 21px;
    line-height: 15px !important;

    &::-webkit-scrollbar {
      width: 3px;
      height: 3px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 2.5px;
      background-color: $scrollbar-color;
    }
  }
  &::v-deep .v-input__slot {
    transition: none;
    margin-bottom: 0;
  }
  &::v-deep .v-text-field__details {
    margin-bottom: 2px;
  }
}

._divider {
  margin-top: -2px;
  padding-top: 12px;
  border-top: 2px solid #e9e9e9;
}

.copy-icon {
  top: 0.45rem;
  right: 0.75rem;
}

.sendEmailButton {
  border-radius: 28px;
  cursor: pointer;
  z-index: 7;
  position: relative;
  display: flex;
  align-items: center;
  width: 170px;
  height: 43px;
  padding: 5px 15px;
  margin-top: -0.5rem;
}

.sendEmailButtonText {
  display: inline-block;
  width: 10rem;
  text-align: center;
  font-size: 16px;
  font-weight: normal;
  line-height: normal;
  letter-spacing: 0.54px;
  color: $black;
  text-transform: capitalize;
}
.messages {
  cursor: pointer;
  &__title {
    .initial_outreach,
    .mail-title {
      font-weight: 600;
      font-size: 14px;
      letter-spacing: 0.23px;
      color: $gray-dark;
    }
    .mail-title {
      font-size: 14px !important;
    }
    &__toggle {
      font-weight: 400;
      font-size: 14px;
      padding-right: 10px;
      color: #6b7280;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 100%;
      max-height: 120px;
      overflow-y: auto;
      &.outreach-template-toggle {
        white-space: pre-wrap;
      }
    }
  }
  .send-date {
    font-weight: 400;
    font-size: 14px;
    color: $placeholder;
  }
}
.threads {
  padding-right: 2px;
  scroll-behavior: smooth;
  &__big-box {
    border-right: 1px solid #f3f4f6;
    border-bottom: 1px solid #c9c9c9;
    margin-right: 2px;
  }
  &__box {
    width: 100%;
    cursor: pointer;
  }
  .sender-name {
    font-weight: 400;
    font-size: 14px;
    color: $black;
  }
  .light-title {
    color: $gray-dark !important;
  }
  .thread-text {
    font-weight: 400;
    font-size: 14px;
    color: $black;
    line-height: 16px;
    display: block;
    &.bold {
      font-weight: bold !important;
    }
  }
  .send-date {
    font-weight: 400;
    font-size: 14px;
    color: #a1a5a6;
  }
  .threads-body {
    display: none;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    &.outreach-template-toggle {
      white-space: pre-wrap;
      display: block;
    }
  }
}
.answer-box {
  &__title {
    border-radius: 2px 2px 0 0;
    color: white;
    background-color: $primary-dark;
    font-size: 14px;
    font-weight: 400;
  }
  &__body {
    border: 1px solid #d8d8d8;
    .answer-box-from {
      font-size: 14px;
      font-weight: 400;
      margin-top: 6px;
      color: $gray-dark;
    }
    .answer-box-sender {
      font-size: 11px;
      font-weight: 400;
      margin-top: 6px;
      color: $gray-light;
    }
    .answer-box-cc {
      margin-top: -12px !important;
    }
    .answer-box-body {
      margin-top: -12px !important;
    }
    .mail-members {
      font-size: 11px;
    }
    .editing-tools {
      display: flex;
      justify-content: center;
      margin-top: -15px;
    }
    .editing-tools__text {
      font-size: 14px;
      font-weight: 400;
      letter-spacing: 0.2px;
      color: $gray-dark;
    }
  }
  &__actions {
    border: 1px solid #d8d8d8;
    border-top: none;
    display: flex;
    padding-top: 6px;
    height: 50px;
    justify-content: space-between;
    &__cancel {
      font-size: 14px;
      text-transform: capitalize !important;
      letter-spacing: 0.23px;
      font-weight: 400;
    }
    &__contact {
      border-radius: 4px;
      text-transform: capitalize !important;
      font-size: 14px;
      font-weight: 400;
      letter-spacing: 0.23px;
      border: 1px solid #c9c9c9;
    }
  }
}
.candidate-contact {
  text-transform: capitalize !important;
  width: 148px;
  height: 30px;
  left: 25%;
  border-radius: 4px;
  border: 1px solid #c9c9c9;
  font-size: 14px;
  letter-spacing: 0.23px;
  font-weight: 400;
}
::-webkit-scrollbar {
  width: 5px;
}
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: #e6e7eb;
}
.contacted-snackbar {
  -webkit-box-shadow: 0px 4px 12px 0px #000000;
  box-shadow: 0px 4px 12px 0px #000000;
}
.success-title {
  font-weight: 600;
  font-size: 14px;
  color: #37b797;
}
.success-text {
  font-weight: 400;
  font-size: 14px;
  color: #37b797;
}
.reply-box {
  width: 240px;
  height: auto;
  border: 1px solid #a1a5a6;
  border-radius: 4px;
  margin: 0 auto;
}
.editor-tool {
  &::v-deep .ql-toolbar {
    width: calc(100% - 16px);
    position: absolute;
    top: 100%;
    padding-left: 40px;
    z-index: 2;
  }
  &::v-deep .ql-container {
    border-bottom: 0 !important;
    border-top: 1px solid #ccc !important;
    height: auto !important;
  }
  &::v-deep .ql-editor {
    max-height: 120px !important;
    min-height: 120px !important;
    font-size: 14px;
    overflow-y: auto !important;
  }
}
.editor-tool {
  &::v-deep .ql-bold:hover {
    color: $brightPurple !important;
  }
}
.send-email {
  position: absolute;
  right: 5px;
  top: 100%;
  width: 44px;
  height: 47.5px;
  border-left: 0;
  z-index: 3;
}
.email-textarea {
  &::v-deep .ql-toolbar.ql-snow .ql-formats {
    margin-right: 0px;
  }
}
::v-deep .ql-toolbar.ql-snow .ql-formats {
  margin-right: 5px;
}
.full-size-dialog {
  &__icon {
    color: $primary !important;
  }
}

.bold-text {
  font-weight: 500;
  color: $black;
}
.light-gray-text {
  font-weight: 500;
  color: $gray-light;
}
.cc-box {
  width: 35%;
  height: 13px;
}
.sub-box {
  width: 100%;
  height: 13px;
}

.bolt-btn {
  position: absolute;
  top: 105%;
  left: 10px;
  z-index: 3;
}
.bolt-btn:hover {
  color: $brightPurple !important;
}
.card {
  &__body {
    width: 587.5px;
    height: 323px;
  }
  &__title {
    width: 100%;
    text-align: center;
    font-size: 16px;
    letter-spacing: 0.2;
    color: $black;
    font-weight: 600;
    padding-top: 15px;
    padding-bottom: 23px;
    border-bottom: solid 1px #dddddd;
  }
  &__close-btn {
    position: absolute;
    right: 2px;
    top: 2px;
  }
  &__box {
    height: 195px;
    border-bottom: solid 1px #dddddd;
    display: flex;
  }
  &__left-item {
    padding-top: 5px;
    width: 235px;
    border-right: solid 1px #dddddd;
    padding-left: 25px;
  }
  &__right-item {
    width: 352.5px;
    padding: 2px 13px 2px 13px;
  }
  &__right-item-body {
    height: 100%;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: 0;
    font-weight: 400;
    color: $black;
    &::v-deep .v-input__slot:after {
      border: none;
    }
    &::v-deep textarea {
      resize: none;
      padding-right: 6.5px;
      height: 100%;
    }
    &::v-deep .v-input__control {
      height: 100%;
    }
    &::v-deep .v-input__slot {
      height: 100%;
    }
    &::v-deep .v-text-field__slot {
      height: 100%;
    }
  }
  &__right-item-body::-webkit-scrollbar {
    display: none;
  }
  &__save-button-box {
    display: flex;
    justify-content: flex-end;
    padding-top: 32px;
  }
  &__save-btn {
    border-radius: 4px;
    &::v-deep .v-btn__content {
      text-transform: initial;
      font-size: 12px;
      color: #ffff;
      letter-spacing: 0.18px;
      font-weight: 400;
    }
  }
  &__footer {
    padding-top: 20px;
    display: flex;
    justify-content: center;
  }
  &__purple-btn {
    border-radius: 4px;
    &::v-deep .v-btn__content {
      text-transform: initial;
      font-size: 16px;
      color: #ffff;
      letter-spacing: 0.2px;
      font-weight: 500;
    }
  }
}
.radio-btn {
  &::v-deep label {
    font-size: 14px;
    letter-spacing: 0.22px;
    color: $black;
    font-weight: 400;
  }
}
.candidate-name-box {
  font-size: 14px;
  color: $gray-dark;
  letter-spacing: 0;
  font-weight: 600;
  padding-top: 4px;
}
.email-cand-box {
  color: $gray-light;
  font-size: 14px;
  letter-spacing: 0;
  font-weight: 500;
  text-transform: uppercase;
  padding-top: 6px;
}
.subj-box {
  color: $gray-dark;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.23px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.email-box {
  padding-top: 8px;
  color: $gray-dark;
  font-size: 14px;
  font-weight: 400;
}
.date-box {
  color: $placeholder;
  font-size: 14px;
  font-weight: 400;
  padding-top: 4px;
}
.email-body-box {
  font-size: 14px;
  padding-top: 12px;
  color: $gray-light;
  line-height: 16px;
}
.first-email-box {
  height: 36px;
  overflow-y: auto;
  cursor: pointer;
  border-bottom: 1px solid $placeholder2;
  align-items: center;
  display: flex;
  justify-content: flex-start;
}
.first-box {
  padding: 12px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.nowrap-box {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.v-tooltip__content {
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
  color: $black !important;
  padding: 4px 2px 4px 2px !important;
  border-radius: 8px !important;
  box-shadow: -1px 1px 4px 0 rgba(0, 0, 0, 0.5);
  opacity: 1 !important;
  line-height: 15px;
}
.select-title {
  padding: 5px 0 5px 0;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: $black;
  border-bottom: solid 1px #dddddd;
}
.select-item {
  color: $black;
  font-weight: 400;
  font-size: 14px;
  padding: 0;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.select-item::before {
  background-color: #f0f0f0;
}
.scroll-bottom-box {
  height: 100%;
  scroll-behavior: smooth;
}
.no-border {
  border-bottom: none !important;
}
.hirefly-message {
  background-color: $title-color;
}
.reply-actions {
  position: relative;
  margin-top: 12px;
}
.fake-email {
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
  img {
    width: 100%;
  }
}
::v-deep {
  .ql-tooltip {
    display: none;
  }
  .ql-toolbar.ql-snow {
    border: none;
    background: #fff;
    border-radius: 8px;
    padding: 4px 12px 2px;
    position: absolute;
    bottom: 61px;
    left: 12px;
    z-index: 40;
    width: calc(100% - 24px);
  }
  .quillWrapper .ql-snow.ql-toolbar .ql-formats {
    margin-bottom: 6px;
  }
  .ql-snow .ql-picker .ql-picker-label:hover {
    color: #5656b2 !important;
  }
  .ql-snow.ql-toolbar .ql-picker-item.ql-selected,
  .ql-snow .ql-toolbar .ql-picker-item.ql-selected,
  .ql-snow.ql-toolbar .ql-picker-item:hover,
  .ql-snow .ql-toolbar .ql-picker-item:hover,
  .ql-snow.ql-toolbar .ql-picker-label.ql-active,
  .ql-snow .ql-toolbar .ql-picker-label.ql-active,
  .ql-snow.ql-toolbar .ql-picker-label:hover,
  .ql-snow .ql-toolbar .ql-picker-label:hover,
  .ql-snow.ql-toolbar button.ql-active,
  .ql-snow .ql-toolbar button.ql-active,
  .ql-snow.ql-toolbar button:focus,
  .ql-snow .ql-toolbar button:focus,
  .ql-snow.ql-toolbar button:hover,
  .ql-snow .ql-toolbar button:hover {
    .ql-stroke {
      stroke: #5656b2 !important;
    }
    .ql-fill {
      fill: #5656b2 !important;
    }
  }
  .ql-picker-item:hover {
    color: #5656b2 !important;
  }
  .custom-textarea {
    padding-top: 12px;
  }
  .ql-container.ql-snow {
    border: none;
    .ql-editor {
      padding: 12px 0px;
      font-size: 14px;
      line-height: 20px;
      font-family: 'Inter';
      font-weight: 400;
    }
  }
  .ql-toolbar.ql-snow .ql-formats {
    margin-right: 0px;
  }
  .ql-editor.ql-blank:before {
    left: 0px;
  }
  .ql-toolbar.ql-snow .ql-picker-options {
    top: auto !important;
    bottom: 100% !important;
  }
}
::v-deep {
  .v-input,
  .v-label {
    font-size: 14px !important;
    color: inherit;
  }
}
</style>
